import { useRef } from 'react';

// eslint-disable-next-line @typescript-eslint/ban-types
export default function useDebounce(fn: Function, delay: number): Function {
  const timeoutRef = useRef<number | undefined>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function debouncedFn(...args: any) {
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(() => {
      fn(...args);
    }, delay);
  }

  return debouncedFn;
}
